<iframe [id]="patientAppIframeName" [title]="patientAppIframeName" [src]="patientAppUrl" class="windowClass"></iframe>